import React from 'react'
import clsx from 'clsx'
import StyledGroup from './styled'

const InputGroup = (props) => {
  const {
    // 参数
    style,
    className,
    children,
  } = props

  return (
    <StyledGroup className={clsx('input-group', className)} style={style}>
      {children}
    </StyledGroup>
  )
}

InputGroup.propTypes = {}

InputGroup.defaultProps = {}

export default InputGroup
